"use strict";

exports.__esModule = true;
exports.BRAND_UNOFORMSE = exports.BRAND_UNOFORMNO = exports.BRAND_UNOFORMBE = exports.BRAND_UNOFORM = exports.BRAND_SIGDAL = exports.BRAND_NOVART = exports.BRAND_NOREMA = exports.BRAND_MARBODAL = exports.BRAND_MAGNETTRADE = exports.BRAND_MAGNET = exports.BRAND_KEITTIOMAAILMA = exports.BRAND_INVITA = exports.BRAND_INTUO = exports.BRAND_HTHSE = exports.BRAND_HTHNO = exports.BRAND_HTHGO = exports.BRAND_HTHFI = exports.BRAND_HTHDK = exports.BRAND_HTHDE = exports.BRAND_EWEEN = exports.BRAND_EWE = void 0;
var BRAND_MAGNET = exports.BRAND_MAGNET = 'magnet';
var BRAND_MAGNETTRADE = exports.BRAND_MAGNETTRADE = 'magnettrade';
var BRAND_HTHGO = exports.BRAND_HTHGO = 'hthgo';
var BRAND_HTHDK = exports.BRAND_HTHDK = 'hthdk';
var BRAND_HTHDE = exports.BRAND_HTHDE = 'hthde';
var BRAND_HTHNO = exports.BRAND_HTHNO = 'hthno';
var BRAND_HTHSE = exports.BRAND_HTHSE = 'hthse';
var BRAND_HTHFI = exports.BRAND_HTHFI = 'hthfi';
var BRAND_KEITTIOMAAILMA = exports.BRAND_KEITTIOMAAILMA = 'keittiomaailma';
var BRAND_NOREMA = exports.BRAND_NOREMA = 'norema';
var BRAND_MARBODAL = exports.BRAND_MARBODAL = 'marbodal';
var BRAND_UNOFORM = exports.BRAND_UNOFORM = 'unoform';
var BRAND_UNOFORMNO = exports.BRAND_UNOFORMNO = 'unoformno';
var BRAND_UNOFORMSE = exports.BRAND_UNOFORMSE = 'unoformse';
var BRAND_UNOFORMBE = exports.BRAND_UNOFORMBE = 'unoformbe';
var BRAND_SIGDAL = exports.BRAND_SIGDAL = 'sigdal';
var BRAND_EWE = exports.BRAND_EWE = 'ewe';
var BRAND_EWEEN = exports.BRAND_EWEEN = 'eween';
var BRAND_INTUO = exports.BRAND_INTUO = 'intuo';
var BRAND_INVITA = exports.BRAND_INVITA = 'invita';
var BRAND_NOVART = exports.BRAND_NOVART = 'novart';